/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ShipmentLimits,
} from '../models/index';
import {
    ShipmentLimitsFromJSON,
    ShipmentLimitsToJSON,
} from '../models/index';

/**
 * 
 */
export class ShipmentLimitsApi extends runtime.BaseAPI {

    /**
     * Returns the limits the backend enforces on shipment quoting requests (line-item dimensions, weights, liftgate caps, etc.). The dashboard reads this on load so it can apply the same limits client-side. Anonymous so it can be called before login. 
     * Get shipment input limits
     */
    async getShipmentLimitsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShipmentLimits>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/shipment-limits`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShipmentLimitsFromJSON(jsonValue));
    }

    /**
     * Returns the limits the backend enforces on shipment quoting requests (line-item dimensions, weights, liftgate caps, etc.). The dashboard reads this on load so it can apply the same limits client-side. Anonymous so it can be called before login. 
     * Get shipment input limits
     */
    async getShipmentLimits(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShipmentLimits> {
        const response = await this.getShipmentLimitsRaw(initOverrides);
        return await response.value();
    }

}
